<template>
    <div class="wrapper-body flex-1">
        <DeliveryNotes />
    </div>
</template>

<script>
import DeliveryNotes from '@/components/DeliveryNotes.vue';
	
    export default {
		name: 'DeliveryNotesView',
        components: { DeliveryNotes },
        data () {
            return {}
        },
	}
</script>